const isCartPage = window.document.body.classList.contains('template-cart');

async function getCart() {
  return fetch(`${window.Shopify.routes.root}cart.js`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`Failed to get cart: ${response.status}`);
    }
    return response.json();
  });
}

async function changeCartItem(key, quantity, properties) {
  return fetch(`${window.Shopify.routes.root}cart/change.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: key,
      quantity,
      properties,
    }),
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`Failed to change cart: ${response.status}`);
    }
    return response.json();
  });
}

const getCartProductIds = () => {
  const productIds = [];

  window.document
    .querySelectorAll('.cart-items .cart-item')
    ?.forEach((item) => productIds.push(item.getAttribute('product-id')));

  return productIds;
};

const getVerifyFitmentLabelHtml = (fits, productType) => {
  return `
    <div class="cm_vehicle-widget cm_vehicle-widget__verify-fitment cm_vehicle-widget__verify-fitment__cart">
      <div class="cm_vehicle-widget_label cm_verify-fitment cm_verify-fitment__${fits}">
        <div class="cm_verify-fitment_title">
          ${
            fits === 'aggressive'
              ? `Vehicle modifications may be required to fit your vehicle`
              : `This ${productType} ${fits === 'yes' ? 'fits' : 'does not fit'} your vehicle`
          } 
        </div>
      </div>
    </div>
  `;
};

const hideCartVerifyFitmentLabels = () => {
  const productIds = getCartProductIds();

  if (productIds?.length > 0) {
    productIds.forEach((productId) => {
      window.document.getElementById(`cm_verify-fitment-label-container-${productId}`).style.display = 'none';
    });
  }
};

async function updateCartVerifyFitmentLabels(vehicle) {
  const vehicleString = `${Object.values(vehicle).join(' ')}`;

  if (vehicleString) {
    const cart = await getCart();

    if (cart?.items?.length > 0) {
      for (const item of cart.items) {
        try {
          const fits = await window.Convermax.verifyFitmentAsync(item.product_id.toString(), vehicle);

          if (fits === 'yes' || fits === 'no' || fits === 'aggressive') {
            const containerElem = window.document.getElementById(
              `cm_verify-fitment-label-container-${item.product_id}`,
            );

            if (containerElem) {
              const productType = containerElem.getAttribute('product-type');
              const verifyFitmentLabel = getVerifyFitmentLabelHtml(fits, productType);
              containerElem.innerHTML = verifyFitmentLabel;
              containerElem.style.display = 'block';

              item.properties['Verify Message'] = `${
                fits === 'aggressive'
                  ? `Vehicle modifications may be required to fit your ${vehicleString}`
                  : `This ${productType} ${fits === 'yes' ? 'fits' : 'does not fit'} your ${vehicleString}`
              }`;
            }
          }
        } catch {
          item.properties['Verify Message'] = 'Failed verify vehicle';
          hideCartVerifyFitmentLabels();
        }

        item.properties.Vehicle = vehicleString;
        await changeCartItem(item.key, item.quantity, item.properties);
      }
    }
  }
}

export async function onVehicleDiscarded() {
  if (isCartPage) {
    hideCartVerifyFitmentLabels();

    const cart = await getCart();

    if (cart?.items?.length > 0) {
      for (const item of cart.items) {
        item.properties.Vehicle = 'Vehicle is not selected';
        item.properties['Verify Message'] = 'Failed verify vehicle';

        await changeCartItem(item.key, item.properties);
      }
    }
  }
}

export const onVehicleSelected = (vehicle) => {
  if (isCartPage && Object.keys(vehicle).length > 0) {
    updateCartVerifyFitmentLabels(vehicle);
  }
};

export const AfterInit = () => {
  const vehicle = window.Convermax.getVehicle();

  if (isCartPage && Object.keys(vehicle).length > 0) {
    updateCartVerifyFitmentLabels(vehicle);
  }
};
